
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Navigation from "@/components/Navigation";
import { MobileNavBar } from "@/components/navigation/MobileNavBar";
import { Toaster } from "@/components/ui/toaster";
import { useAuth, AuthProvider } from "@/contexts/AuthContext";
import { useState } from "react";
import Home from "@/pages/Home";
import Feed from "@/pages/Feed";
import Inbox from "@/pages/Inbox";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import Quix from "@/pages/Quix";
import Communities from "@/pages/Communities";
import Forums from "@/pages/Forums";
import PostDetail from "@/pages/PostDetail";
import Lessons from "@/pages/Lessons";
import LessonDetail from "@/pages/LessonDetail";
import { startupRoutes } from "@/routes/startupRoutes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function AppContent() {
  const { user, loading } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900" />
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-background">
        <Navigation isOpen={isOpen} setIsOpen={setIsOpen} />
        <main className="container mx-auto max-w-7xl pt-16 px-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/communities" element={<Communities />} />
            <Route path="/communities/lessons" element={<Lessons />} />
            <Route path="/communities/lessons/:id" element={<LessonDetail />} />
            <Route path="/f" element={<Forums />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/feed/post/:id" element={<PostDetail />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/quix" element={<Quix />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            {startupRoutes}
          </Routes>
        </main>
        <MobileNavBar user={user} />
        <Toaster />
      </div>
    </Router>
  );
}

function App() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
